"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingSpinner = void 0;
var LoadingSpinner_1 = require("./LoadingSpinner");
Object.defineProperty(exports, "LoadingSpinner", { enumerable: true, get: function () { return LoadingSpinner_1.LoadingSpinner; } });
//# sourceMappingURL=index.js.map